import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import './i18n';
// import history from './helper/history/history';
import store from './store';

import reportWebVitals from './reportWebVitals';
import App from './App';
import 'flag-icons/css/flag-icons.min.css';
// import './index.css';
import './assets/styles/app.scss';
import 'react-chat-elements/dist/main.css';
import SpinnerLoading from './components/Loaders/SpinnerLoading';

ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback={<SpinnerLoading applyViewHeight />}>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
